var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6.3983,
    height: 23.903,
    fill: "none",
    viewBox: "0 0 6.3983 23.903",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#757575",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.9241 22.779c1.1476-0.405 1.7533-1.6565 1.3529-2.7952s-1.6552-1.7335-2.8028-1.3284c-1.1476 0.405-1.7533 1.6565-1.3529 2.7952 0.40038 1.1387 1.6552 1.7335 2.8028 1.3284z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.9242 14.014c1.1475-0.4051 1.7532-1.6566 1.3529-2.7953-0.4004-1.1387-1.6553-1.7334-2.8029-1.3284-1.1475 0.4051-1.7533 1.6565-1.3529 2.7952 0.4004 1.1387 1.6553 1.7335 2.8029 1.3285z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.9242 5.2481c1.1475-0.405 1.7532-1.6565 1.3529-2.7952-0.4004-1.1387-1.6553-1.7335-2.8029-1.3284-1.1475 0.40505-1.7533 1.6565-1.3529 2.7952 0.4004 1.1387 1.6553 1.7335 2.8029 1.3284z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu_icon.8b522e8af56651b24a5598bae50dd232.svg";
export { ForwardRef as ReactComponent };